import { GET_MODULES } from "lib/constants";
import { getAPICall } from "../lib/callApi";

export const getUserModules = async (module) => {
  const data = await getAPICall(GET_MODULES, true, { module });
  return data;
};
